//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { DaySelectionDisplayItem } from './DaySelectionDisplayItem';
import { CalendarColorMode, CalendarResourceMode, CalendarDragAndDropMode } from './Enums';

export class TeacherCalendarPreferencesDisplayItem extends ItemBase {
    ColorMode: CalendarColorMode = CalendarColorMode.EventCategory;
    ResourceMode: CalendarResourceMode = CalendarResourceMode.Teacher;     // OBSOLETE - Use only for compatibility
    DefaultEventVisibilityIsPublic: boolean = false;
    DragAndDropMode: CalendarDragAndDropMode = CalendarDragAndDropMode.ChangeTeacher;
    ShowBirthdays: boolean = false;
    ShowEventCategoryName: boolean = false;
    ShowEventPrice: boolean = false;
    ShowOnlyMyOwnEvents: boolean = false;
    ShowOpenSlotCount: boolean = false;
    ShowRepertoirePerformances: boolean = false;
    StartingHourForDayOrWeekView: number = 0;
    VisibleDays: DaySelectionDisplayItem | null = null;

    constructor(initializer?: Partial<TeacherCalendarPreferencesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherCalendarPreferencesDisplayItem";
}
